import { Box, Stack, Typography } from "fashion/fabrics";
import { BookIcon } from "fashion/icons";
import BlogHeaderShare from "nodes/blog/BlogHeaderShare";
import useBlogPost from "gears/blog/useBlogPost";
import { POST_INDEX } from "names/blog";

type Props = {
  postIndex: POST_INDEX;
};

const BlogHeader = ({ postIndex }: Props) => {
  const post = useBlogPost(postIndex);
  return (
    <>
      <Box display="flex" gap={1} alignItems="center">
        <BookIcon fontSize="large" />
        <Stack>
          <Typography fontWeight="500">Card Memoir Article</Typography>
          <Typography variant="body2" color="text.secondary">
            Published {post.date}
          </Typography>
        </Stack>
        <Box flexGrow={1} />
        <BlogHeaderShare post={post} />
      </Box>
      <Box display="flex" justifyContent="center">
        <img
          style={{ maxWidth: `min(100%, ${post.imgSize}px)` }}
          src={post.imgSrc}
          alt="Banner"
        />
      </Box>
      <Typography color="secondary" variant="h3">
        {post.name}
      </Typography>
    </>
  );
};

export default BlogHeader;
